var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Recharge" },
    [
      _c("div", { staticClass: "pay-type-box" }, [
        _c(
          "ul",
          { staticClass: "paychannel" },
          _vm._l(_vm.channel, function (item) {
            return _c(
              "li",
              {
                key: item.id,
                class: { active: _vm.activeChannelId == item.id },
                on: {
                  click: function ($event) {
                    return _vm.selectedChannel(item.id)
                  },
                },
              },
              [
                _c("div", { staticClass: "channel" }, [
                  _c("img", { attrs: { src: _vm._f("imgfilter")(item.icon) } }),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(item.payPlace)),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "pay-value-box" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.activeChannel.coinTypes &&
                  _vm.activeChannel.coinTypes.length > 0,
                expression:
                  "activeChannel.coinTypes && activeChannel.coinTypes.length > 0",
              },
            ],
            staticClass: "amountlist",
          },
          [
            [
              _vm._l(_vm.activeChannel.coinTypes, function (item, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    class: [_vm.activeCoinType === item ? "active" : ""],
                    on: {
                      click: function ($event) {
                        _vm.activeCoinType = item
                      },
                    },
                  },
                  [_c("div", { staticClass: "price" }, [_vm._v(_vm._s(item))])]
                )
              }),
              _c("span", { staticClass: "fake" }),
              _c("span", { staticClass: "fake" }),
              _c("span", { staticClass: "fake" }),
              _c("span", { staticClass: "fake" }),
              _c("span", { staticClass: "fake" }),
              _c("span", { staticClass: "fake" }),
              _c("span", { staticClass: "fake" }),
            ],
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "pay-value-box" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.channel.length > 0,
                  expression: "channel.length > 0",
                },
              ],
              staticClass: "amountlist",
            },
            [
              _vm.activeChannel.isSnRecharge == 0
                ? [
                    _vm._l(
                      _vm.priceList.filter(function (_) {
                        return _.payPlace == _vm.activeChannelId
                      }),
                      function (item, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            class: [
                              _vm.activeNumber === item.id ? "active" : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.selectAmount(item.id)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "price" }, [
                              _vm._v(_vm._s(item.amount)),
                            ]),
                            item.baseGift > 0 || item.firstRechargeAmount > 0
                              ? _c("i", [
                                  _vm._v(
                                    "+" + _vm._s(_vm.GenGiftRate(item)) + "%"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }
                    ),
                    _c("span", { staticClass: "fake" }),
                    _c("span", { staticClass: "fake" }),
                    _c("span", { staticClass: "fake" }),
                    _c("span", { staticClass: "fake" }),
                    _c("span", { staticClass: "fake" }),
                    _c("span", { staticClass: "fake" }),
                    _c("span", { staticClass: "fake" }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.activeChannel.isSnRecharge == 1
            ? [
                _c("div", { staticClass: "sn-input-box" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sn,
                        expression: "sn",
                      },
                    ],
                    staticClass: "sign-up__field__input",
                    attrs: { placeholder: "请输入充值码", type: "text" },
                    domProps: { value: _vm.sn },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.sn = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "label",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeChannel.exchangeRate != 1,
              expression: "activeChannel.exchangeRate != 1",
            },
          ],
        },
        [_vm._v(" " + _vm._s(_vm.exchangeInfoText) + " ")]
      ),
      _vm.targetPrice.baseGift < 0
        ? _c(
            "div",
            { staticStyle: { color: "#e44242", "margin-top": "4px" } },
            [_vm._v(" " + _vm._s(_vm.feeInfoText) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "sign-up__content" }, [
        _vm.showNameInput || _vm.showIDInput || _vm.showMobileInput
          ? _c("label", [
              _vm._v("付款人信息 "),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "13px", color: "red" },
                  on: {
                    click: function ($event) {
                      _vm.modal7 = true
                    },
                  },
                },
                [
                  _c("Icon", {
                    attrs: { type: "md-information-circle", size: "16" },
                  }),
                  _vm._v("填写错误不会到账 "),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.showNameInput
          ? _c("div", { staticClass: "sign-up__field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                staticClass: "sign-up__field__input",
                attrs: { placeholder: "付款人姓名", type: "text", id: "name" },
                domProps: { value: _vm.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm.showIDInput
          ? _c("div", { staticClass: "sign-up__field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.id,
                    expression: "id",
                  },
                ],
                staticClass: "sign-up__field__input",
                attrs: {
                  placeholder: "付款人的身份证号码",
                  type: "text",
                  id: "id",
                },
                domProps: { value: _vm.id },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.id = $event.target.value
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm.showMobileInput
          ? _c("div", { staticClass: "sign-up__field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mobile,
                    expression: "mobile",
                  },
                ],
                staticClass: "sign-up__field__input",
                attrs: {
                  placeholder: "付款人手机号码",
                  type: "text",
                  id: "mobile",
                },
                domProps: { value: _vm.mobile },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.mobile = $event.target.value
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm.CurAmount || _vm.activeChannel.isSnRecharge > 0
        ? _c(
            "div",
            {
              staticClass: "pay-btn-box",
              class: { disabled: !_vm.isPaymentEnabled },
            },
            [
              !_vm.qrcodeModal.btnLoading
                ? _c(
                    "div",
                    {
                      staticClass: "recharge-button",
                      on: {
                        click: function ($event) {
                          return _vm.submitpay()
                        },
                      },
                    },
                    [_vm._v(" 立即充值 ")]
                  )
                : _c("div", { staticClass: "recharge-button" }, [
                    _c("i", {
                      staticClass: "ivu-icon ivu-icon-md-sync pay-loding-ico",
                    }),
                    _vm._v("创建订单中,请稍后 "),
                  ]),
            ]
          )
        : _vm._e(),
      _vm.qrcodeModal.btnLoading
        ? _c("div", { staticClass: "payment-mask" })
        : _vm._e(),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            width: "550rem",
            "footer-hide": "",
            closable: false,
          },
          model: {
            value: _vm.qrcodeModal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.qrcodeModal, "flag", $$v)
            },
            expression: "qrcodeModal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "扫描二维码以完成支付", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.qrcodeModal.flag = false
                },
              },
            },
            [
              _vm.CurChannel && _vm.qrcodeModal.paystate == 0
                ? _c(
                    "div",
                    { staticClass: "qrcode_box" },
                    [
                      _c("vue-qr", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          correctLevel: 0,
                          text: _vm.qrcodeModal.qr_codeurl,
                          size: 400,
                        },
                      }),
                      _vm.isMobile()
                        ? _c("div", { staticClass: "qrcode_text" }, [
                            _c("p", [_vm._v("手机支付请保存二维码到相册扫码")]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _c("div", { staticClass: "qrcode_box" }, [
                    _c("div", { staticClass: "success-box" }, [
                      _c("i", {
                        staticClass: "ivu-icon ivu-icon-md-checkmark-circle",
                      }),
                    ]),
                    _c("div", { staticClass: "qrcode_text" }, [
                      _c("p", [
                        _vm._v(
                          "支付成功,订单号: " +
                            _vm._s(_vm.qrcodeModal.curOrderid)
                        ),
                      ]),
                    ]),
                  ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }